import React from 'react'
import styled from 'styled-components'
import img from '../assets/wolfie.jpg'


const VideoContainer = styled.div`
width: 100%;

video{
    width: 100%;
    height: auto;
}

@media (max-width: 64em) {
  min-width: 40vh;
}
`

const ImageContainer = styled.div`
width: 110%;
background-color:${props => props.theme.carouselColor};
border: 1px solid ${props => props.theme.text};
padding: 0.5rem;

border-radius: 2px;
display: flex;
justify-content: flex-start;

img{
  width: 110%;
  max-width: 100%;
  height: auto;
transition: all 0.3s ease;

}
`

const CoverVideo = () => {
  return (
    <ImageContainer>
        <img width={1024} height={1024}  src={img} alt="Lone Wolf" />
    </ImageContainer>
  )
}

export default CoverVideo